import $api from "@/zapi-frontend/shared/api/axios";
import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import type { TDimensionType } from "../lib/dimensionForm";

export type TCreateProjectDimensionPayload = {
  orgId: number;
  name: string;
  type: TDimensionType;
  options: string[];
  color: string;
};

export function useCreateProjectDimension(
  options?: UseMutationOptions<
    TOrganizationProjectDimension,
    AxiosError<{ message: string }>,
    TCreateProjectDimensionPayload
  >
) {
  return useMutation({
    mutationKey: ["createProjectDimension"],
    mutationFn: async ({ orgId, name, type, options: opts, color }: TCreateProjectDimensionPayload) => {
      const { data } = await $api.post<{ data: TOrganizationProjectDimension }>(
        `/organizations/${orgId}/project-dimensions`,
        { name: name.trim(), type, options: type === "dropdown" ? opts : [], color }
      );
      return data.data;
    },
    ...options
  });
}
